import { useOktaAuth } from "@okta/okta-react";
import { testApiCall } from "../../services/connexionApi/connexionApi";

/**
 * @const Profil display the Profil page
 * @returns {JSX.Element} HTML content
 */
const Profil = () => {

  /* we retrieve the connected user */
  const { authState } = useOktaAuth();

  const idToken = authState!.idToken!.idToken
  
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleClick = () => {
    void testApiCall(idToken);
  };
  
  return (
    <>
    <div className="rootHome"><button onClick={handleClick}>Click me</button></div>
    </>
  );
};

export { Profil };